// setup custom namespace
if (typeof RVC !== "object") {
  window.RVC = {};
}
window.RVC.pageLength = 100;
